"use strict";

import React from "react";
import { DropdownTheme } from "./DropdownTheme";
var DropdownContext = React.createContext({
  theme: DropdownTheme.Light
});
export { DropdownContext };